cb.define([], function () {
  var AA_aa_productsofstorelist_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {

    }
  }
  try {
    module.exports = AA_aa_productsofstorelist_VM_extend;
  } catch(error){
  }
  return AA_aa_productsofstorelist_VM_extend;

});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_productsofstorelist_VM.Extend.js